import styled from "styled-components";
import { motion } from "framer-motion";
import { Link } from "react-scroll";

/* Navbar */
export const Navbar = styled.nav`
  position: fixed;
  top: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.9);
  padding: 10px 0;
  text-align: center;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 6px 0;
  }
`;

export const NavLinks = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 90%;
  max-width: 600px;
  gap: 15px;

  a {
    font-size: 1.2rem;
    font-weight: 600;
    padding: 6px 10px;
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      color: #ffcc00;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    gap: 10px;
    
    a {
      font-size: 1rem;
      padding: 5px 8px;
    }
  }

  @media (max-width: 480px) {
    width: 95%;
    gap: 8px;

    a {
      font-size: 0.9rem;
      padding: 4px 6px;
    }
  }
`;



export const Hero = styled.section`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10%;
  background: linear-gradient(to bottom, #1a1a1a, #2e2e2e, #3a3a3a);
  position: relative;

  @media (max-width: 1024px) {
    flex-direction: column-reverse;
    justify-content: center;
    text-align: center;
    height: auto;
    padding: 8%;
  }
`;

export const HeroText = styled.div`
  max-width: 50%;
  text-align: left;

  h1 {
    font-size: 4.5rem;
    color: #ffcc00;
    text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
  }

  h2 {
    font-size: 1.5rem;
    color: #e0e0e0;
    margin-top: 10px;
  }

  p {
    font-size: 1.3rem;
    color: #ccc;
    margin-top: 20px;
    line-height: 1.6;
  }

  @media (max-width: 1024px) {
    max-width: 100%;
    text-align: center;

    h1 {
      font-size: 3.5rem;
    }

    p {
      font-size: 1.2rem;
    }
  }
`;

export const HeroImage = styled(motion.img)`
  width: 340px;
  height: auto;
  border-radius: 15px;
  object-fit: cover;
  border: 5px solid transparent; 
  background: linear-gradient(135deg, #ffcc00, #ffdd44);
  padding: 5px; 
  box-shadow: 0px 4px 15px rgba(255, 255, 255, 0.2), 
              0px 6px 30px rgba(0, 0, 0, 0.3);
  transition: 0.3s ease-in-out;

  &:hover {
    box-shadow: 0px 6px 20px rgba(255, 255, 255, 0.4), 
                0px 8px 40px rgba(0, 0, 0, 0.4);
  }

  @media (max-width: 1024px) {
    width: 260px;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    width: 200px; 
    margin-bottom: 15px;
  }
`;




/* Button Container */
export const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 30px;
`;

/* Resume Button */
export const ResumeButton = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 12px 25px;
  font-size: 1.2rem;
  font-weight: 600;
  color: black;
  background: #ffcc00;
  border-radius: 8px;
  text-decoration: none;
  transition: 0.3s ease-in-out;
  gap: 10px;

  &:hover {
    background: white;
    color: black;
    box-shadow: 2px 2px 10px rgba(255, 255, 255, 0.2);
  }
`;

/* Contact Button */
export const ContactButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 12px 25px;
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
  background: none;
  border: 2px solid #ffcc00;
  border-radius: 8px;
  text-decoration: none;
  transition: 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    background: #ffcc00;
    color: black;
  }
`;

/* Sections */
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 120px 10%;
  width: 100%;
  min-height: auto;
`;

/* About Section (Ensuring Proper Title & Text Size) */
export const AboutSection = styled(Section)`
  background: linear-gradient(to bottom, #3a3a3a 0%, #4a4a4a 40%, #5e5e5e 100%);
  min-height: auto;
  padding: 140px 10%;

  h2 {
    font-size: 4.2rem;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    margin-bottom: 50px;
    color: white;
  }

  p {
    font-size: 1.4rem;
    font-family: 'Poppins', sans-serif;
    max-width: 900px;
    line-height: 1.8;
    margin-bottom: 20px;
    color: white;
  }
`;



/* Projects Section (Fix Overlap & Expand Dynamically) */
export const ProjectsSection = styled(Section)`
  background: linear-gradient(to bottom, #5e5e5e 0%, #727272 50%, #8a8a8a 100%);
  min-height: auto;
  padding-top: 140px;
  padding-bottom: 140px;
  width: 100%;

  h2 {
    font-size: 4.2rem;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    margin-bottom: 50px;
    color: white;
  }
`;



/* Wrapper for Centering Project Cards */
export const ProjectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 900px;
  gap: 50px;
  margin-top: 30px;
`;



/* Clickable Project Cards */
export const ProjectCard = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 700px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: 0.3s ease-in-out;
  cursor: pointer;
  text-align: center;
  border: 2px solid transparent;
  text-decoration: none;

  h3 {
    font-size: 2rem;
    font-family: 'Poppins', sans-serif;
    font-weight: bold;
    color: #ffcc00;
    margin-bottom: 15px;
  }

  p {
    font-size: 1.4rem;
    font-family: 'Poppins', sans-serif;
    color: white;
    line-height: 1.6;
    max-width: 600px;
  }

  &:hover {
    border-color: #ffcc00;
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.02);
  }
`;

/* Contact Section */
export const ContactSection = styled(Section)`
  background: linear-gradient(to bottom, #8a8a8a 0%, #a0a0a0 50%, #c0c0c0 100%);
  min-height: auto;
  padding-bottom: 80px;

  h2 {
    font-size: 3.3rem;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    margin-bottom: 50px;
    color: white;
  }
`;


/* Form Container (Centers Everything) */
export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 500px;
  margin-top: 20px;
`;

/* Input Container (Wraps Name & Subject Fields) */
export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  width: 100%;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const InputField = styled.input`
  width: 100%;
  padding: 15px;
  font-size: 1rem;
  border: 2px solid #ffcc00;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  outline: none;
  transition: 0.3s ease-in-out;
  margin-top: 10px;
  text-align: left;

  &::placeholder {
    color: #f8f8f8;
    font-weight: 500;
    opacity: 1;
  }

  &:focus {
    border-color: black;
    background: white;
    color: black;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 10px;
  }
`;

export const MessageBox = styled.textarea`
  width: 100%;
  height: 150px;
  padding: 15px;
  font-size: 1rem;
  border: 2px solid #ffcc00;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  outline: none;
  transition: 0.3s ease-in-out;
  margin-top: 10px;
  resize: none;
  text-align: left;

  &::placeholder {
    color: #f8f8f8;
    font-weight: 500;
    opacity: 1;
  }

  &:focus {
    border-color: black;
    background: white;
    color: black;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 10px;
  }
`;


/* Send Button */
export const SendButton = styled.button`
  margin-top: 15px;
  padding: 12px 25px;
  font-size: 1.1rem;
  font-weight: 600;
  color: black;
  background: #ffcc00;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s ease-in-out;

  &:hover {
    background: black;
    color: white;
  }
`;
